<template>
  <main>
		<header class="page header">
			<div class="content row">
        <div class="col-4">
          <h4 class="mt-3 mb-3 ml-5 light">Scripts</h4>
        </div>
      </div>
    </header>
    <div class="row frame">
      <div class="col-3">
        <div v-for="script in scripts" class="script-list">
          <a href="javascript:;" v-on:click="changeScript(script)">{{script.label}}</a>
        </div>
      </div>
      <div class="col-3">
        <component :is="options" />
      </div>
      <div class="col-6">
        <component :is="history" />
      </div>
    </div>
  </main>
</template>

<script>
import Data from '../../main';

export default {
	name: 'Scripts',
	props: {
		// current: Object
	},
	methods: {
		changeScript: function( script ) {
			this.current = script;
		},
	},
	data: function() {
		return {
			scripts: Data.scripts,
			current: Data.scripts[0],
			options: () => {},
			history: () => {},
		};
	},
	watch: {
		current: function() {
			this.options = () => import(`./${this.current.name}/options`);
			this.history = () => import(`./${this.current.name}/history`);
		},
	},
	mounted: function() {
		this.options = () => import(`./${this.current.name}/options`);
		this.history = () => import(`./${this.current.name}/history`);
	},
};
</script>

<style scoped lang="less">
  .frame {
    border-top: 1px solid #efefef;
    display: flex;

    .script-list a{
      display: block;
      border-bottom: 1px solid #efefef;
      padding: 20px;
      font-size: 20px;
      margin-right: -15px;

      &:hover{
        background: #efefef;
      }
    }

     > div {
      height: 100vh;
      border-left: 1px solid #efefef;
    }
  }

</style>
